var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("Labels", { attrs: { card: _vm.card } }),
      _vm._v(" "),
      _c("CardInfo", {
        attrs: {
          state: _vm.state,
          board: _vm.board,
          flow: _vm.flow,
          card: _vm.card
        },
        on: {
          "open-system-attributes": function($event) {
            return _vm.$emit("open-system-attributes")
          }
        }
      }),
      _vm._v(" "),
      _c("Attachments", {
        attrs: {
          state: _vm.state,
          board: _vm.board,
          flow: _vm.flow,
          card: _vm.card,
          readonly: _vm.readonly,
          lockeddown: _vm.lockeddown,
          modalId: _vm.modalId
        }
      }),
      _vm._v(" "),
      _c("Description", {
        staticClass: "my-2",
        attrs: {
          state: _vm.state,
          board: _vm.board,
          flow: _vm.flow,
          card: _vm.card,
          readonly: _vm.readonly,
          lockeddown: _vm.lockeddown,
          userEmails: _vm.userEmails
        }
      }),
      _vm._v(" "),
      _c("Tasks", {
        staticClass: "my-2",
        attrs: {
          state: _vm.state,
          board: _vm.board,
          flow: _vm.flow,
          card: _vm.card,
          readonly: _vm.readonly,
          lockeddown: _vm.lockeddown
        }
      }),
      _vm._v(" "),
      _c("Comments", {
        staticClass: "my-2",
        attrs: {
          state: _vm.state,
          card: _vm.card,
          readonly: _vm.readonly,
          lockeddown: _vm.lockeddown,
          userEmails: _vm.userEmails
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }